import type { Plan } from '@/lib/billing/billing-package';

export const DAY_MS = 86_400_000;

/** Whole days remaining until the trial ends (rounded up, min 0). */
export function daysUntilTrialEnds(trialEndsAt: number): number {
  return Math.max(0, Math.ceil((trialEndsAt - Date.now()) / DAY_MS));
}

/**
 * The company is trialing (paid plan) and the trial ends within `withinDays`.
 * Drives the in-app reminder banner.
 */
export function isTrialEndingSoon(
  plan: Plan | undefined,
  trialEndsAt: number | undefined,
  withinDays = 3,
): boolean {
  if (!plan || plan === 'free' || !trialEndsAt) return false;
  const now = Date.now();
  return trialEndsAt > now && trialEndsAt <= now + withinDays * DAY_MS;
}

/**
 * The trial has lapsed and the company has fallen back to the Free plan.
 * (`trialEndsAt` is kept permanently as a "has trialed" marker.)
 */
export function isTrialExpired(
  plan: Plan | undefined,
  trialEndsAt: number | undefined,
): boolean {
  return (
    (!plan || plan === 'free') && !!trialEndsAt && trialEndsAt < Date.now()
  );
}
